<template>
    <div class="page form">
        <div class="form-header">
            <div class="form-header-title">{{ $t('content.follow.form.title') }}</div>
            <!-- <div class="form-header-title">1232131</div> -->
            <div class="form-header-back" @click="close">
                <i class="el-icon-close"></i>
            </div>
        </div>
        <div class="contact-us">
            <div class="contact-form">
                <div class="contact-form-cont">
                    <div class="contact-form-form">
                        <form>
                            <div class="form-group">
                                <label>{{ $t('content.follow.form.label.know') }}</label>
                                <el-select v-model="formData.question_type_id" :placeholder="$t('error.select')"
                                    style="width: 100%;">
                                    <el-option v-for="op in knowOPtions" :key="op.id" :label="op.name" :value="op.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- <div class="form-group">
                                <label>{{ $t('content.follow.form.label.identity') }}</label>
                                <el-select v-model="formData.body_option" :placeholder="$t('error.select')"
                                    style="width: 100%;">
                                    <el-option v-for="op in bodyOPtions" :key="op.value" :label="op.label"
                                        :value="op.value">
                                    </el-option>
                                </el-select>
                            </div> -->
                            <div class="form-group">
                                <label>{{ $t('content.follow.form.label.fullname') }}</label>
                                <input class="form-control" v-model="formData.full_name" type="text"
                                    :placeholder="$t('home.inquiryCont.form.a3')">
                            </div>
                            <div class="form-group">
                                <label>{{ $t('content.follow.form.label.contact') }}</label>
                                <input class="form-control" v-model="formData.mobile" type="text"
                                    :placeholder="$t('home.inquiryCont.form.a4')">
                            </div>
                            <div class="form-group">
                                <label>{{ $t('content.follow.form.label.email') }}</label>
                                <input class="form-control" type="email" v-model="formData.email"
                                    :placeholder="$t('home.inquiryCont.form.a5')">
                            </div>
                            <!-- <div class="form-group">
                                <label>{{ $t('content.follow.checkboxGroup.title') }}</label>
                                <div class="form-check" v-for="check in checkOptions" :key="check.id">
                                    <input class="form-check-input" type="checkbox" v-model="formData.problem"
                                        :value="check.id">
                                    <label class="form-check-label" for="defaultCheck1">
                                        {{ check.name }}
                                    </label>
                                </div>
                            </div> -->
                            <button type="submit" class="submit-button" @click.prevent="submit">
                                {{ $t('content.follow.form.buttonText') }}
                            </button>
                            <!-- <div class="contact-form-note">
                                Note：{{ $t('home.inquiryCont.form.note') }}
                            </div> -->
                        </form>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { bus } from '@/utils/bus'
import { getQuestionType, submitQuestion, getSolveOption } from "@/api/komo"
export default {
    data() {
        return {
            knowOPtions: [],
            bodyOPtions: this.$t('content.follow.identityOPtions'),
            checkOptions: [],
            formData: {
                question_type_id: '',
                // body_option: '',
                full_name: '',
                mobile: '',
                email: '',
                // preferred_city: '',
                // problem: []
            },
        }
    },
    created() {
        this.initData()
    },
    methods: {
        // 初始化表单选择项数据
        initData() {
            getQuestionType().then(res => {
                this.knowOPtions = res?.data?.list
            })
            getSolveOption().then(res => {
                this.checkOptions = res?.data?.list
            })
        },
        // 提交表单
        async submit() {
            if (!this.formData.question_type_id) {
                this.$message.error(this.$t('error.select'))
                return;
            }
            // 校验身份
            // if (this.formData.body_option ===''|| this.formData.body_option == null) {
            //     this.$message.error(this.$t('error.select'))
            //     return;
            // }
            // 校验名字
            if (!this.formData.full_name) {
                this.$message.error(this.$t('error.name'))
                return;
            }

            // 校验手机号
            if (!this.formData.mobile) {
                this.$message.error(this.$t('error.phone'))
                return;
            }
            if (!this.validatePhone(this.formData.mobile)) {
                this.$message.error(this.$t('error.phoneFormat'))
                return;
            }
            // 校验邮箱
            if (!this.formData.email) {
                this.$message.error(this.$t('error.email'))
                return;
            }
            if (!this.validateEmail(this.formData.email)) {
                this.$message.error(this.$t('error.emailFormat'))
                return;
            }
            
            // 校验checkbox
            // if (!this.formData.problem.length >0 ) {
            //     this.$message.error(this.$t('error.select'))
            //     return;
            // }
            const params = {
                question_type_id: this.formData.question_type_id,
                body_option: "consumer",
                // body_option: this.formData.body_option === 0 ? "consumer" : "franchisee",
                full_name: this.formData.full_name,
                mobile: this.formData.mobile,
                email: this.formData.email,
                // preferred_city: this.formData.preferred_city,
                // problem: this.formData.problem
            }
            // console.log('submit123', params)
            const res = await submitQuestion(params)
            if (res?.error === 0) {
                this.$message.success(res?.message)
                this.formData =  {
                    question_type_id: '',
                    full_name: '',
                    mobile: '',
                    email: ''
                }
                setTimeout(() => this.close(), 1000)

            } else {
                this.$message.error(res?.message)
            }

        },
        //验证手机号格式
        validatePhone(phone) {
            // 验证手机号是否为纯数字
            const numberRegex = /^1[34578]\d{9}$/;
            return numberRegex.test(phone);
        },
        //验证邮箱格式
        validateEmail(email) {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return emailRegex.test(email);
        },
        // 关闭全局组件表单
        close() {
            bus.$emit('inquiry-form', false)
        }
    },
}
</script>
<style scoped>
.form {
    width: 100%;
    height: 100vh;
    background: #FFFFFF;
}

.form-header {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 20px 10px 0 10px;
}

.form-header-title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 5vw;
    color: #1E1E1E;
}

.form-header-back {
    position: absolute;
    font-size: 5vw;
    right: 30px;
}

.contact-form {
    width: 100%;
    background: #FFFFFF;
    padding-top: 5%;
}

.contact-form-bottom {
    width: 100%;
    height: 90vh;
}

.contact-form-cont {
    width: 100%;
}

.contact-form-title {
    margin: 0;
    padding: 8% 0 5% 0;
    text-align: center;
    font-weight: bold;
    font-size: 2rem;
    color: #1E1E1E;
}

.contact-form-form {
    background: #FFFFFF;
    padding: 20px;
    border-radius: 20px;
}

.contact-form-form form{
	display: flex;
    flex-direction: column;
    gap: 3vh;	
}

.submit-button {
    width: 22vh;
    padding: 2vw 3vw;
    background-color: #333;
    color: #fff;
    border: none;
    border-radius: 10.67vw;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.submit-button:hover {
    background-color: #555;
}

.submit-button:active {
    background-color: #222;
}

.contact-form-note {
    color: #959595;
    font-size: 3vw;
}
</style>